import styled from '../../utils/styled';
import { mediaBreakpointDownMD } from '../../../constants/style-constants';

export const ButtonContainer = styled.button(({ open }) => ({
  width: '136px',
  border: 'none',
  color: '#fff',
  padding: '7px',
  paddingBottom: '30px',
  marginBottom: open ? '-10px' : '0',
  marginLeft: '10px',
  backgroundColor: open ? '#101010' : '#0f0f0f',
  cursor: 'pointer',
  fontFamily: '"Spyscapetwo webfont", sans-serif',
  lineHeight: '2.17',
  fontSize: '12px',
  fontWeight: '300',
  textTransform: 'uppercase',
  alignItems: 'baseline',
  justifyContent: 'center',
  position: 'relative',
  display: 'flex',
  borderBottom: open ? 'none' : '1px solid #4ec3f7',
  height: open ? '50px' : '40px',
  transition: 'background-color 0.3s linear',
  outline: 'none',

  '&:hover': {
    backgroundColor: '#383838',
  },

  [mediaBreakpointDownMD]: {
    display: 'none',
  },

  '> img': {
    transition: 'transform 0.3s linear',
    transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
  },
}));

export const ButtonText = styled.div({
  display: 'block',
  paddingRight: '10px',
  fontFamily: "'Spyscapetwo webfont',sans-serif",
});

export const ButtonIcon = styled.img({
  display: 'block',
});
